<template>
    <div :class="tournoi.demo ? 'demo' : ''" v-show="joueurInviteInTournoi || club.public">
        <div :class="tournoi.state=='FINISH' ? 'sheaderFinish' : 'sheader'">
            <b>{{formatDate(tournoi.date)}} à {{tournoi.heure}} </b>
            <div class="buttonDelete">
            <s-button icon="cog" label="" theme="is-light is-small" 
                @onclick="$emit('edit')" :role="role"    :disabled="isOffline" />
                &nbsp;&nbsp;
            <s-button icon="trash" label="" theme="is-danger is-small" 
                @onclick="$emit('delete')" :role="role"    :disabled="isOffline" />
            </div>
        </div>
        <s-demo v-if="tournoi.demo"/>
        <div class="descriptionBox">
            <div class="description">
            <s-fil :options="tournoi.options"/>
                <div><s-l id="listitem_joueursInscrits" :v="tournoi.joueurs.length"> %v joueurs inscrits</s-l></div>
            </div>
        <div class="description">
                {{tournoi.description}}
            </div>
            <s-button  label="debug" v-if="isAdminSite" @onclick="copyToDebug"/>
            <div  v-if="tournoi.saison!=null" class="descSaison">
                <s-l v-if="tournoi.saison!=null"  id="concours_appartientA" :v="getSaison(tournoi.saison)">Appartient à la saison %v</s-l>
            </div>
            <div  v-else class="descSaison">
                <s-l v-if="tournoi.saison==null"  id="concours_notsaison">Aucune saison</s-l>
                <div v-if="tournoi.public"  style="float:right" >
                <s-l id="concours_ouvertAtous">Ce concours est ouvert à tous</s-l>
                </div>
                <div  v-if="!tournoi.public" style="float:right">
                    <s-l id="concours_private">Ce concours privé</s-l>
                </div>
            </div>
            
            
            <div class="menuButtons" v-if="!$isAnonyme() && joueurInviteInTournoi && $getRole()!='visiteur'">
                <div>
                    <s-button icon="film" label="Inclure dans une saison" 
                        theme="is-primary is-medium " 
                        @onclick="$emit('openListSaison')"
                        mode="V"
                        v-if="!tournoi.saison "
                        :role="role"
                        :disabled="isOffline"
                    />
                    <s-button icon="unlink"  v-if="tournoi.saison  "
                            label="Enlever de la saison" theme="is-medium is-danger" 
                            @onclick="$emit('detacherSaison')"
                            mode="V"
                            :role="role"/>
                </div>
                <div  >
                    <s-button icon="gamepad" label="Mes parties" 
                        theme="is-info is-medium " 
                        v-if="tournoi.state=='INPROGRESS'  "
                        @onclick="goMonTournoi" 
                        v-show="inJoueurInTournoi==1"
                        :disabled="isOffline"
                        mode="V"
                    /> 
                    
                    <s-button icon="signature" 
                        :label="labelInscription" 
                        :theme="themeInscription + ' is-medium'"
                        v-if="tournoi.state=='INSCRIPTION' && tournoi.options.subscribe"
                        @onclick="goMonTournoi" 
                        v-show="inJoueurInTournoi!=null"
                        :disabled="isOffline || dateLimit()"
                        mode="V"
                    />
                </div>
                <div >
                    <s-button icon="copy"
                        label="Copier"
                        theme="is-medium is-primary"
                        mode="V"
                        @onclick="dupliquer()"
                        :role="role"   
                        :disabled="isOffline"
                    />
                </div>
                <div>
                    <s-button v-if="tournoi.state=='INSCRIPTION' " icon="file-signature" 
                        label="Inscription des joueurs" 
                        theme="is-primary is-medium" 
                        @onclick="$emit('open')" 
                        mode="V" 
                        :role="role"
                        />
                    <s-button v-if="tournoi.state=='INPROGRESS' " icon="play" label="En cours" 
                        theme="is-success is-medium " 
                        @onclick="$emit('open')" 
                        mode="V" />
                    <s-button v-if="tournoi.state=='FINISH' " icon="award" label="Resultat" 
                        theme="is-success is-medium " 
                        @onclick="$emit('open')" 
                        mode="V" />
                </div>
                
            </div>
            <div style="width:100%; text-align:right;margin-top:70px;padding-right: 20px"  v-if="$isAnonyme() || !joueurInviteInTournoi || $getRole()=='visiteur'">
                    <s-button v-if="tournoi.state=='INPROGRESS'" icon="lock" 
                            label="Voir le concours" 
                            theme="is-primary is-large " 
                            @onclick="$emit('open')" 
                        />
                        <s-button v-if="tournoi.state=='FINISH'" 
                            icon="lock" 
                            label="Voir les résultats" 
                            theme="is-success is-large " 
                            @onclick="$emit('open')" 
                        />
                        <div  v-if="tournoi.state=='FINISH' || tournoi.state=='INPROGRESS'">
                        <i><b>Un code est nécessaire</b></i>
                        </div>
                        <div  v-if="tournoi.state=='INSCRIPTION'">
                        <i><b>Ce concours n'a pas démarré</b></i>
                        <div v-if="tournoi.public" style="float:left">
                            <s-button icon="signature" 
                                label="Je souhaite y  participer" 
                                theme="is-info is-medium"
                                @onclick="souhaitParticiper" 
                                :disabled="isOffline"
                                mode="V"
                            />
                        </div>
                        </div>
                </div>
        </div>
    </div>
</template>
<style scoped>
   .descriptionBox {
       border: thin solid var(--bluebg);
       padding: 10px;
   }
    .menuButtons {
        width: 97%;
        box-shadow: 0px -1px 4px 1px rgb(165, 165, 165);
        margin: 10px;
        height: 130px;
    }
    .menuButtons div {
        display: table-cell;
        vertical-align: top;
        padding-top: 20px;
        text-align: center;
        width: 20%;
        padding-left: 5px;
        padding-right: 5px;
        
    }
    .descSaison {
        text-align: left;
        height: 50px;
        padding-top: 5px;
        color: black;
        font-weight: bolder;
    }    
    .descSuite {
        padding-top: 10px;
    }
    .sheader {
        background-color: var(--bluebg);
        color: white;
        padding: 10px;
    }
    .sheaderFinish {
        background-color: #3a3a3b;
        color: white;
        padding: 10px;
    }
     @media screen and (min-width: 420px) {  
        .description {
            color: black;
            font-weight: bolder;
            height: 20px;
            margin-bottom: 20px;
        }
    }
    @media screen and (max-width: 420px) {  
        .description {
            color: black;
            font-weight: bolder;
            height: 15px;
            font-size: 14px;
            margin-bottom: 20px;
        }
    }
    .tournoiState {
        cursor: help;
    }
    .planifExplain {
        display: inline-block;
        font-size: 16px;
    }
    .iconDelay:hover {
        cursor: help;
    }
    .iconDelay {
        border-radius: 20px;
        margin-right: 10px;
        height: 60px;
        width: 60px;
        font-weight: bolder;
        font-size: 20px;
        padding: 5px;
        text-align: center;
        vertical-align: middle;
        padding-top: 15px;
    }
    .M_FREE {
        background-color:rgb(250, 162, 243);
        color: white;
        
    }
    .M_8H {
         background-color: rgb(165, 255, 47);
        color: rgb(2, 110, 60);
    }
    .M_3J {
        background-color: rgb(255, 189, 47);
        color: white;
    }
    .M_5J {
         background-color: rgb(255, 78, 47);
        color: white;
    }
    .formule {
       font-size: 13px;
       font-style: italic;
    }
    .tournoiDate {
        color: black;
        font-weight: bolder;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .tournoi {
        padding: 20px;
        border: thin silver solid;
        padding-bottom: 20px;
        margin-top: 10px;
    }
    .buttonDelete {
        float: right;
        
    }
    
    
    .buttonActive {
        text-align: right;
        padding-top: 20px;
    }
    .buttonGamePad {
        text-align: center;
        padding-top: 20px;
        
    }
    .tournoiState {
        float: left;
        border: thin solid silver;
        border-radius: 20px;
        text-align: center;
        padding: 5px;
        font-size: 14px;
        color: white;
        font-weight: bolder;
        width: 150px;
    }
    .WAITING {
        background-color: rgb(233, 152, 30);
    }
     .INSCRIPTION {
        background-color: rgb(139, 204, 247);
    }
    .INPROGRESS {
        background-color: rgb(49, 233, 24);
    }
    .EXPIRE {
        background-color: rgb(211, 21, 21);
        color: white;
    }
     .FINISH {
        background-color: rgb(23, 26, 23);
        color: white;
    }
    .appartientSaison {
        font-size: 16px;
        font-weight: bolder;
        width: 100%;
        padding: 5px;
        border: thin dashed var(--bluebg);
        margin-top: 10px;
        color: black;
        border-radius: 10px;
        height: 45px;
    }
</style>
<script>
import tournoi_fct from "@/firebase/tournoi"
export default {
    props: ["club","tournoi","role", "saisons"],
    methods: {
        copyToDebug() {
            tournoi_fct.object.copyToDebug(this.club.id, this.tournoi);
        },
        formatDate(date) {
            var options = { year: "numeric", month: "numeric", day: "numeric"};
            return (new Date(date)).toLocaleString("fr-Fr",options);
        },
        formatHeure(date) {
             var dateData = new Date(date);
                if (dateData.getMinutes()<10)
                    var minutes = "0" + dateData.getMinutes();
                else    
                    var minutes = dateData.getMinutes();
                return (dateData.getHours() + ":" + minutes)
        },
        goMonTournoi() {
             this.$router.push({name: "myTournoi", params:{idClub: this.club.id, idTournoi:this.tournoi.id}}).catch(error=>{});
        },
        dupliquer() {
            this.$emit("dupliquer");
        },
        souhaitParticiper() {
            
        },
        getSaison(saisonId) {
                 var saison = null;
                if (typeof(this.saisons)!="undefined") {
                    if (typeof(saisonId)!="undefined") {
                        if (saisonId != null) {
                            var findSaison = this.saisons.findIndex(elt=>elt.id === saisonId);
                            if (findSaison!=-1)
                                saison = this.saisons[findSaison].nom;
                        }                    
                    }
                }
                return saison;
            },
        dateLimit() {
       
           
            if (typeof(this.tournoi)!="undefined") {
                var toDay = new Date();
                var dateCalc = this.$dateLimit(this.tournoi.date, this.tournoi.heure, this.tournoi.options.delaiEmail)
               
                return (toDay.getTime() > dateCalc.getTime()) 
            }
            else 
                return false;
            
        
        }    
    },
    computed: {
        isAdminSite: {
            get() {
                return (typeof(this.$store.getters.getUser.adminSite)!="undefined")
            }
        },
        joueurInviteInTournoi : {
            get() {
               
                if (this.$getRole() == 'invite') {
                    var indexClub = this.$store.getters.getUser.clubs.findIndex(club=>club.idClub == this.club.id);
                    var clubInUser = this.$store.getters.getUser.clubs[indexClub];
              
                    if (typeof(clubInUser.invites)!="undefined") {
                        var index = clubInUser.invites.indexOf(this.tournoi.id);
                        return index!=-1;
                    }
                    return false;
                }
                else
                    return true;
            }
        },
        labelInscription: {
            get() {
                var label="";
                if (this.inJoueurInTournoi == 0) {
                   if (this.joueurPresinscription==0) {
                        label= "Je m'inscris" ;
                        if (this.dateLimit())
                            label+=" (délai expiré)"
                   }
                   else
                        label= "Je suis préinscrit"
                } 
                else    
                    label= 'Je suis inscrit';
                return label;
            }
        },
        themeInscription: {
            get() {
                if (this.inJoueurInTournoi == 0) {
                   if (this.joueurPresinscription==0)
                        return "is-info" ;
                   else
                        return "is-warning"
                } 
                else    
                    return 'is-success'
            }
        },
        joueurPresinscription: {
             get() {
                 if (typeof(this.tournoi)!="undefined") {
                    var idClub = this.$store.getters.getUser.clubs.findIndex(club=>club.idClub == this.club.id);
                        if (idClub != -1) {
                            var idJoueur = this.$store.getters.getUser.clubs[idClub].idJoueur;
                            var joueurs = this.tournoi.preinscription;
                            if (typeof(joueurs)!="undefined") {
                                var findJoueur = joueurs.findIndex(joueur=>joueur === idJoueur);
                                if (findJoueur != -1)
                                    return 1
                                else
                                    return 0;
                                }
                            else
                                return 0;
                        }
                        else
                            return null;
                 }
            }
        },
        inJoueurInTournoi: {
            get() {
                var idClub = this.$store.getters.getUser.clubs.findIndex(club=>club.idClub == this.club.id);
                    if (idClub != -1) {
                        var idJoueur = this.$store.getters.getUser.clubs[idClub].idJoueur;
                        var joueurs = this.tournoi.joueurs;
                        var findJoueur = joueurs.findIndex(joueur=>joueur.id == idJoueur);
                        if (findJoueur != -1)
                            return 1
                        else
                            return 0;
                        }
                    else
                        return null;
            }
        },
     expireExplain: {
         get() {
            switch (this.tournoi.options.delay) {
             case "FREE":
                 return "15 minutes d'utilisation"
                 break;
             case "8H":
                return "8 heures d'utilisation";
                break;
            case "3J":
                return "3 jours d'utilisation";
                break;
            case "5J":
                return "5 jours d'utilisation";
                break;
                
            default:
                 break;
            }
         }
        
     },
     credit: {
          get() {
           
            if (this.$store.getters.getCredit == null)
              return 0;
            else
              return this.$store.getters.getCredit.credit
          }
        },
        
    },
    
}
</script>